import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function getEntityTypeColor(type) {
  const colors = {
    HOLDING: { bg: 'bg-amber-500/20', border: 'border-amber-500', text: 'text-amber-400' },
    LLC: { bg: 'bg-blue-500/20', border: 'border-blue-500', text: 'text-blue-400' },
    TRUST: { bg: 'bg-emerald-500/20', border: 'border-emerald-500', text: 'text-emerald-400' },
    CORPORATION: { bg: 'bg-purple-500/20', border: 'border-purple-500', text: 'text-purple-400' },
    SUBSIDIARY: { bg: 'bg-pink-500/20', border: 'border-pink-500', text: 'text-pink-400' },
  };
  return colors[type] || colors.LLC;
}

export function getEntityTypeIcon(type) {
  const icons = {
    HOLDING: 'Landmark',
    LLC: 'Building2',
    TRUST: 'Shield',
    CORPORATION: 'Briefcase',
    SUBSIDIARY: 'GitBranch',
  };
  return icons[type] || 'Building2';
}
